/**
 * Resolve a product image's `storage_path` to a browser-loadable src.
 * Bucket-relative paths are served same-origin via the `/api/shop-image` proxy;
 * any legacy external URL (pre-migration) is returned unchanged.
 */
export function storageImageSrc(storagePath: string): string {
  return storagePath.startsWith("http")
    ? storagePath
    : `/api/shop-image/${storagePath.replace(/^\/+/, "")}`;
}
